// import React, { useEffect, useState } from 'react';
// import Loader from '../Shared/Loader';
// import ReactPaginate from 'react-paginate';
// import { FaAssistiveListeningSystems } from 'react-icons/fa';
// import { AiOutlineDownload } from 'react-icons/ai';
// import { useSelector } from 'react-redux';


// const MobileAnswers = ({ setAudioData }) => {
//     const [searchResult, setSearchResult] = useState([]);
//     const [isSearching, setIsSearching] = useState(false);
//     const [pageCount, setPageCount] = useState(0);
//     const [start, setStart] = useState(0);
//     const [end, setEnd] = useState(30);

//     let allAnswer = useSelector((state) => state.boyan.allanswer[0]);
//     const category = useSelector((state) => state.boyan.answer_category); 

//     const answers = category === "all" ? allAnswer : allAnswer.filter(answer => answer.category === category);


//     useEffect(() => {
//         setPageCount(Math.ceil(answers.length / 30));
//     }, [answers.length])

//     const handleSearchResult = (event) => {
//         const searchText = event.target.value;
//         const match = answers.filter(answer => answer.question.includes(searchText));
//         setSearchResult(match);
//         setIsSearching(true);
//     }

//     const handlePlayAudio = (answer) => {
//         setAudioData(answer);
//         const newView= answer.view ? answer.view : 0;
//         const view= parseInt(newView)+1;
//         const viewCount= {view};

//         fetch(`https://madrumi.thakurgaonexpress.com/getanswer/${answer?._id}`, {
//             method: 'PATCH',
//             headers: {
//                 'content-type': 'application/json'
//             },
//             body: JSON.stringify(viewCount)
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log(data);

//             })

//     }
//     const handleDownloadCount = (answer) => {
//         const newDownload= answer.download ? answer.download : 0;
//         const download= parseInt(newDownload)+1;
//         const downloadCount= {download};

//         fetch(`https://madrumi.thakurgaonexpress.com/getanswer/${answer?._id}`, {
//             method: 'PATCH',
//             headers: {
//                 'content-type': 'application/json'
//             },
//             body: JSON.stringify(downloadCount)
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log(data);
//             })

//     }

//     let st = 0;
//     let en = 30;

//     const handlePageClick = (data) => {
//         if (data.selected + 1 < 3) {
//             st = st * data.selected + 1 * 30;
//         } else {
//             st = st * data.selected + 1 * 30 + 30;
//         }

//         if (data.selected + 1 <= 1) {
//             st = 0
//             en = 30
//         }
//         en = en * data.selected + 30;
//         setStart(st);
//         setEnd(en);
//         window.scrollTo(0, 0);
//     }

//     const reloadFn = () => {
//         setStart(st);
//         setEnd(en);
//     }

//     return (
//         <div className='w-10/12 lg:w-11/12 mx-auto mt-16 relative'>
//             <h1 className='text-xl border-b-4 border-accent font-bold mt-8 inline-block'>মুফতি শফি সাহেব (দাঃ বাঃ) এর {category === "all" ? "সকল প্রশ্ন-উত্তর" : category + " বিষয়ে প্রশ্ন-উত্তর"}</h1><br />
//             <div className='flex justify-center items-center my-4'>
//                 <div class="form-control w-80">
//                     <label class="label">
//                         <span class="label-text font-bold">প্রশ্নের বিষয় লিখে অনুসন্ধান করুন</span>
//                     </label>
//                     <input onMouseDown={reloadFn} onChange={handleSearchResult} type="text" placeholder="প্রশ্নের বিষয় লিখুন" class="input input-bordered input-accent w-full max-w-xs" />
//                 </div>
//             </div>

//             <hr />
//             <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5'>
//                 {
//                     isSearching ? searchResult.slice(start, end).map(answer => <div style={{ height: '250px' }} className='shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative'>
//                         <h3 className='text-lg font-bold min-h-8'>প্রশ্নঃ {answer.question}</h3>
//                         <h3 className='text-base'><span className='font-bold'>উত্তর নংঃ</span> {answer.answer_no}  <span className='font-bold'>  বিভাগঃ</span> {answer.category}</h3>
//                         <div className='flex flex-row'>
//                             <FaAssistiveListeningSystems className='text-xs' />
//                             <p className='ml-px text-xs'>{answer?.view}</p>
//                             <AiOutlineDownload className='text-xs ml-2' />
//                             <p className='ml-px text-xs'>{answer?.download}</p>
//                         </div>
//                         <div className='mt-4 text-center absolute bottom-6 rounded-2xl left-12 shadow-2xl p-2'>
//                             <label onClick={() => handlePlayAudio(answer)} for="my-modal-6" class="btn btn-accent btn-circle text-white font-bold mr-12">শুনুন
//                             </label>
//                             <label onClick={()=>handleDownloadCount(answer)} for="my-modal-6" class="btn btn-accent text-white font-bold mr-2"><a href={answer.link}>ডাউনলোড</a>
//                             </label>
//                         </div>
//                     </div>) : answers.slice(start, end).map(answer => <div style={{ height: '250px' }} className='shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative'>
//                         <h3 className='text-lg font-bold min-h-8'>প্রশ্নঃ {answer.question}</h3>
//                         <h3 className='text-base'><span className='font-bold'>উত্তর নংঃ</span> {answer.answer_no}  <span className='font-bold'>  বিভাগঃ</span> {answer.category}</h3>
//                         <div className='flex flex-row'>
//                             <FaAssistiveListeningSystems className='text-xs' />
//                             <p className='ml-px text-xs'>{answer?.view}</p>
//                             <AiOutlineDownload className='text-xs ml-2' />
//                             <p className='ml-px text-xs'>{answer?.download}</p>
//                         </div>
//                         <div className='mt-4 text-center absolute bottom-6 rounded-2xl left-12 shadow-2xl p-2'>
//                             <label onClick={() => handlePlayAudio(answer)} for="my-modal-6" class="btn btn-accent btn-circle text-white font-bold mr-12">শুনুন
//                             </label>
//                             <label onClick={()=>handleDownloadCount(answer)} for="my-modal-6" class="btn btn-accent text-white font-bold mr-2"><a href={answer.link}>ডাউনলোড</a>
//                             </label>
//                         </div>
//                     </div>)
//                 }
//             </div>
//             <div className='mt-8 mb-20'>
//                 {answers.length > 8 && <ReactPaginate
//                     previousLabel={'পূর্ববর্তী'}
//                     nextLabel={'পরবর্তী'}
//                     breakLabel={'...'}
//                     pageCount={pageCount}
//                     marginPagesDisplayed={3}
//                     pageRangeDisplayed={6}
//                     onPageChange={handlePageClick}
//                     containerClassName={'btn-group justify-center'}
//                     pageClassName={'btn btn-accent text-white'}
//                     activeClassName={'btn bg-white text-black'}
//                     previousClassName={'btn btn-accent text-white'}
//                     nextClassName={'btn btn-accent text-white'}
//                     breakClassName={'btn btn-accent text-white'}></ReactPaginate>}
//             </div>
//         </div >
//     );
// };

// export default MobileAnswers;

// import React, { useEffect, useState } from 'react';
// import Loader from '../Shared/Loader';
// import ReactPaginate from 'react-paginate';
// import { FaAssistiveListeningSystems } from 'react-icons/fa';
// import { AiOutlineDownload } from 'react-icons/ai';
// import { useSelector } from 'react-redux';
// import { openDB } from 'idb';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const MobileAnswers = ({ setAudioData }) => {
//     const [searchResult, setSearchResult] = useState([]);
//     const [isSearching, setIsSearching] = useState(false);
//     const [pageCount, setPageCount] = useState(0);
//     const [start, setStart] = useState(0);
//     const [end, setEnd] = useState(30);
//     const [downloadProgress, setDownloadProgress] = useState({});
//     const [downloadComplete, setDownloadComplete] = useState({});

//     let allAnswer = useSelector((state) => state.boyan.allanswer[0]);
//     const category = useSelector((state) => state.boyan.answer_category);
//     const answers = category === "all" ? allAnswer : allAnswer.filter(answer => answer.category === category);

//     // Initialize IndexedDB
//     const initDB = async () => {
//         const db = await openDB('AudioDB', 1, {
//             upgrade(db) {
//                 const store = db.createObjectStore('audioFiles', { keyPath: '_id' });
//                 store.createIndex('question', 'question', { unique: false });
//             }
//         });
//         return db;
//     };

//     useEffect(() => {
//         // Load download status from localStorage on component mount
//         const downloadedFiles = JSON.parse(localStorage.getItem('downloadedFiles')) || {};
//         setDownloadComplete(downloadedFiles);

//         setPageCount(Math.ceil(answers.length / 30));
//     }, [answers.length]);

//     const handleSearchResult = (event) => {
//         const searchText = event.target.value;
//         const match = answers.filter(answer => answer.question.includes(searchText));
//         setSearchResult(match);
//         setIsSearching(true);
//     };

//     const handlePlayAudio = (answer) => {
//         setAudioData(answer);
//         const newView = answer.view ? answer.view : 0;
//         const view = parseInt(newView) + 1;
//         const viewCount = { view };

//         fetch(`https://madrumi.thakurgaonexpress.com/getanswer/${answer?._id}`, {
//             method: 'PATCH',
//             headers: {
//                 'content-type': 'application/json'
//             },
//             body: JSON.stringify(viewCount)
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log(data);
//             });
//     };

//     // Handle Download and save to IndexedDB
//     const handleDownloadAndSave = async (answer) => {
//         const db = await initDB();

//         // Check if the file has already been downloaded
//         if (downloadComplete[answer._id]) {
//             return;
//         }

//         const audioBlob = await fetchAudioFile(answer.link, answer._id); // Download audio file as Blob

//         // Save Blob and question to IndexedDB with the required _id key
//         await db.put('audioFiles', { blob: audioBlob, type: ' প্রশ্ন-উত্তর', question: answer.question }, answer._id);

//         const updatedDownloadComplete = { ...downloadComplete, [answer._id]: true };
//         setDownloadComplete(updatedDownloadComplete); // Mark the file as downloaded

//         // Store updated status in localStorage
//         localStorage.setItem('downloadedFiles', JSON.stringify(updatedDownloadComplete));

//         handleDownloadCount(answer);

//         // Show success toast notification
//         toast.success('File downloaded successfully!');
//     };

//     const fetchAudioFile = async (url, id) => {
//         const response = await fetch(url);
//         const reader = response.body.getReader();
//         const contentLength = +response.headers.get('Content-Length');

//         let receivedLength = 0; // Received length of data
//         let chunks = []; // Array to hold the downloaded chunks

//         while (true) {
//             const { done, value } = await reader.read();

//             if (done) break;

//             chunks.push(value);
//             receivedLength += value.length;

//             // Calculate and set download progress for the specific file
//             const progress = (receivedLength / contentLength) * 100;
//             setDownloadProgress(prev => ({ ...prev, [id]: progress }));
//         }

//         // Create Blob from downloaded chunks
//         const blob = new Blob(chunks);
//         return blob;
//     };

//     const handleDownloadCount = (answer) => {
//         const newDownload = answer.download ? answer.download : 0;
//         const download = parseInt(newDownload) + 1;
//         const downloadCount = { download };

//         fetch(`https://madrumi.thakurgaonexpress.com/getanswer/${answer?._id}`, {
//             method: 'PATCH',
//             headers: {
//                 'content-type': 'application/json'
//             },
//             body: JSON.stringify(downloadCount)
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log(data);
//             });
//     };

//     let st = 0;
//     let en = 30;

//     const handlePageClick = (data) => {
//         if (data.selected + 1 < 3) {
//             st = st * data.selected + 1 * 30;
//         } else {
//             st = st * data.selected + 1 * 30 + 30;
//         }

//         if (data.selected + 1 <= 1) {
//             st = 0;
//             en = 30;
//         }
//         en = en * data.selected + 30;
//         setStart(st);
//         setEnd(en);
//         window.scrollTo(0, 0);
//     };

//     const reloadFn = () => {
//         setStart(st);
//         setEnd(en);
//     };



//     return (
//         <div className='w-10/12 lg:w-11/12 mx-auto mt-16 relative'>
//             <ToastContainer />
//             <h1 className='text-xl border-b-4 border-accent font-bold mt-8 inline-block'>
//                 মুফতি শফি সাহেব (দাঃ বাঃ) এর {category === "all" ? "সকল প্রশ্ন-উত্তর" : category + " বিষয়ে প্রশ্ন-উত্তর"}
//             </h1><br />
//             <div className='flex justify-center items-center my-4'>
//                 <div className="form-control w-80">
//                     <label className="label">
//                         <span className="label-text font-bold">প্রশ্নের বিষয় লিখে অনুসন্ধান করুন</span>
//                     </label>
//                     <input
//                         onMouseDown={reloadFn}
//                         onChange={handleSearchResult}
//                         type="text"
//                         placeholder="প্রশ্নের বিষয় লিখুন"
//                         className="input input-bordered input-accent w-full max-w-xs"
//                     />
//                 </div>
//             </div>

//             <hr />

//             <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5'>
//                 {isSearching ? searchResult.slice(start, end).map(answer => (
//                     <div key={answer._id} style={{ height: '250px' }} className='shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative'>
//                         <h3 className='text-lg font-bold min-h-8'>প্রশ্নঃ {answer.question}</h3>
//                         <h3 className='text-base'><span className='font-bold'>উত্তর নংঃ</span> {answer.answer_no}  <span className='font-bold'>  বিভাগঃ</span> {answer.category}</h3>
//                         <div className='flex flex-row'>
//                             <FaAssistiveListeningSystems className='text-xs' />
//                             <p className='ml-px text-xs'>{answer?.view}</p>
//                             <AiOutlineDownload className='text-xs ml-2' />
//                             <p className='ml-px text-xs'>{answer?.download}</p>
//                         </div>
//                         <div className='mt-4 text-center absolute bottom-6 rounded-2xl left-12 shadow-2xl p-2'>
//                             <label onClick={() => handlePlayAudio(answer)} htmlFor="my-modal-6" className="btn btn-accent btn-circle text-white font-bold mr-12">শুনুন</label>
//                             <label
//                                 onClick={() => handleDownloadAndSave(answer)}
//                                 className={`btn ${downloadComplete[answer._id] ? 'btn-gray text-gray-500 cursor-not-allowed' : 'btn-accent text-white font-bold'}`}
//                                 disabled={downloadComplete[answer._id]}
//                             >
//                                 {downloadComplete[answer._id] ? 'Downloaded' : 'ডাউনলোড'}
//                             </label>
//                             {downloadProgress[answer._id] && downloadProgress[answer._id] < 100 && (
//                                 <div className='progress' style={{ backgroundColor: '#f0f0f0', borderRadius: '8px', height: '10px', marginTop: '2px' }}>
//                                     <div
//                                         className='progress-bar'
//                                         role='progressbar'
//                                         style={{
//                                             width: `${Math.max(downloadProgress[answer._id], 1)}%`,
//                                             backgroundColor: '#4caf50', // Set your preferred color here
//                                             height: '100%',
//                                             borderRadius: '8px',
//                                             transition: 'width 0.5s ease' // Smooth transition
//                                         }}
//                                     >
//                                         {Math.round(downloadProgress[answer._id])}%
//                                     </div>
//                                 </div>
//                             )}


//                         </div>
//                     </div>
//                 )) : answers.slice(start, end).map(answer => (
//                     <div key={answer._id} style={{ height: '250px' }} className='shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative'>
//                         <h3 className='text-lg font-bold min-h-8'>প্রশ্নঃ {answer.question}</h3>
//                         <h3 className='text-base'><span className='font-bold'>উত্তর নংঃ</span> {answer.answer_no}  <span className='font-bold'>  বিভাগঃ</span> {answer.category}</h3>
//                         <div className='flex flex-row'>
//                             <FaAssistiveListeningSystems className='text-xs' />
//                             <p className='ml-px text-xs'>{answer?.view}</p>
//                             <AiOutlineDownload className='text-xs ml-2' />
//                             <p className='ml-px text-xs'>{answer?.download}</p>
//                         </div>
//                         <div className='mt-4 text-center absolute bottom-6 rounded-2xl left-12 shadow-2xl p-2'>
//                             <label onClick={() => handlePlayAudio(answer)} htmlFor="my-modal-6" className="btn btn-accent btn-circle text-white font-bold mr-12">শুনুন</label>
//                             <label
//                                 onClick={() => handleDownloadAndSave(answer)}
//                                 className={`btn ${downloadComplete[answer._id] ? 'btn-gray text-gray-500 cursor-not-allowed' : 'btn-accent text-white font-bold'}`}
//                                 disabled={downloadComplete[answer._id]}
//                             >
//                                 {downloadComplete[answer._id] ? 'Downloaded' : 'ডাউনলোড'}
//                             </label>
//                             {downloadProgress[answer._id] && downloadProgress[answer._id] < 100 && (
//                                 <div className='progress' style={{ backgroundColor: '#f0f0f0', borderRadius: '8px', height: '10px', marginTop: '2px' }}>
//                                     <div
//                                         className='progress-bar'
//                                         role='progressbar'
//                                         style={{
//                                             width: `${Math.max(downloadProgress[answer._id], 1)}%`,
//                                             backgroundColor: '#4caf50', // Set your preferred color here
//                                             height: '100%',
//                                             borderRadius: '8px',
//                                             transition: 'width 0.5s ease' // Smooth transition
//                                         }}
//                                     >
//                                         {Math.round(downloadProgress[answer._id])}%
//                                     </div>
//                                 </div>
//                             )}


//                         </div>
//                     </div>
//                 ))}
//             </div>
//             <div className="flex justify-center mt-5">
//                 <ReactPaginate
//                     previousLabel={"previous"}
//                     nextLabel={"next"}
//                     breakLabel={"..."}
//                     pageCount={pageCount}
//                     marginPagesDisplayed={2}
//                     pageRangeDisplayed={5}
//                     onPageChange={handlePageClick}
//                     containerClassName={"pagination"}
//                     pageClassName={"page-item"}
//                     pageLinkClassName={"page-link"}
//                     previousClassName={"page-item"}
//                     previousLinkClassName={"page-link"}
//                     nextClassName={"page-item"}
//                     nextLinkClassName={"page-link"}
//                     breakClassName={"page-item"}
//                     breakLinkClassName={"page-link"}
//                     activeClassName={"active"}
//                 />
//             </div>
//         </div>
//     );
// };

// export default MobileAnswers;


import React, { useEffect, useState } from 'react';
import Loader from '../Shared/Loader';
import ReactPaginate from 'react-paginate';
import { FaAssistiveListeningSystems } from 'react-icons/fa';
import { AiOutlineDownload } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { openDB } from 'idb';

const MobileAnswers = ({ setAudioData }) => {
    const [searchResult, setSearchResult] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [downloadProgress, setDownloadProgress] = useState({});
    const [downloadComplete, setDownloadComplete] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [answers, setAnswers] = useState([]); // Store the answers fetched from backend
    const [totalAnswers, setTotalAnswers] = useState(0); // Store total answers from backend

    const limit = 10; // Number of answers per page

    let allAnswer = useSelector((state) => state.boyan.allanswer[0]); // Redux answers
    const category = useSelector((state) => state.boyan.answer_category); // Redux category

    // Load downloaded files status from localStorage on component mount
    useEffect(() => {
        const downloadedFiles = JSON.parse(localStorage.getItem('downloadedFiles')) || {};
        setDownloadComplete(downloadedFiles);

        // Fetch answers from backend initially
        fetchAnswersFromBackend(currentPage, "", category);
    }, [currentPage, category]); // Fetch answers when the page or category changes

    // Fetch answers from backend with pagination, search, and category filters
    // Fetch answers from backend with pagination, search, and category filters
    const fetchAnswersFromBackend = async (page = 1, search = "", category = "all") => {
        setIsLoading(true);
        try {
            // Normalize category to lowercase before sending to the backend
            const response = await fetch(`https://madrumi.thakurgaonexpress.com/getanwerswithfilter?page=${page}&limit=${limit}&search=${search}&category=${category.toLowerCase()}`);
            const data = await response.json();

            setAnswers(data.total); // Set answers based on pagination
            setPageCount(Math.ceil(data.document / limit)); // Set total pages based on document count
            setTotalAnswers(data.document); // Store total answers count
        } catch (error) {
            console.error("Error fetching answers:", error);
        }
        setIsLoading(false);
    };


    // Handle search input
    const handleSearchResult = (event) => {
        const searchText = event.target.value;
        setIsSearching(true);

        if (category === 'all') {
            // Fetch answers from backend when category is "all"
            fetchAnswersFromBackend(1, searchText, category);
        } else {
            // Filter the current loaded answers locally for other categories
            const filteredAnswers = allAnswer.filter(answer =>
                answer.category === category &&
                answer.question.toLowerCase().includes(searchText.toLowerCase())
            );
            setAnswers(filteredAnswers);
        }
    };


    const handlePlayAudio = (answer) => {
        setAudioData(answer);
        const newView = answer.view ? answer.view : 0;
        const view = parseInt(newView) + 1;
        const viewCount = { view };

        fetch(`https://madrumi.thakurgaonexpress.com/getanswer/${answer?._id}`, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(viewCount)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
            });
    };


    // Handle Download and save to IndexedDB
    // Initialize IndexedDB
    const initDB = async () => {
        const db = await openDB('AudioDB', 1, {
            upgrade(db) {
                const store = db.createObjectStore('audioFiles', { keyPath: '_id' });
                store.createIndex('name', 'name', { unique: false });
            }
        });
        return db;
    };

    const handleDownloadAndSave = async (answer) => {
        const db = await initDB();

        // Check if the file has already been downloaded
        if (downloadComplete[answer._id]) {
            return;
        }

        const audioBlob = await fetchAudioFile(answer.link, answer._id); // Download audio file as Blob

        // Save Blob and question to IndexedDB with the required _id key
        await db.put('audioFiles', { blob: audioBlob, type: 'প্রশ্ন-উত্তর', name: answer.question }, answer._id);

        const updatedDownloadComplete = { ...downloadComplete, [answer._id]: true };
        setDownloadComplete(updatedDownloadComplete); // Mark the file as downloaded

        // Store updated status in localStorage
        localStorage.setItem('downloadedFiles', JSON.stringify(updatedDownloadComplete));

        handleDownloadCount(answer);

        // Show success toast notification
        toast.success('File downloaded successfully!');
    };

    const fetchAudioFile = async (url, id) => {
        const response = await fetch(url);
        const reader = response.body.getReader();
        const contentLength = +response.headers.get('Content-Length');

        let receivedLength = 0; // Received length of data
        let chunks = []; // Array to hold the downloaded chunks

        while (true) {
            const { done, value } = await reader.read();

            if (done) break;

            chunks.push(value);
            receivedLength += value.length;

            // Calculate and set download progress for the specific file
            const progress = (receivedLength / contentLength) * 100;
            setDownloadProgress(prev => ({ ...prev, [id]: progress }));
        }

        // Create Blob from downloaded chunks
        const blob = new Blob(chunks);
        return blob;
    };

    const handleDownloadCount = (answer) => {
        const newDownload = answer.download ? answer.download : 0;
        const download = parseInt(newDownload) + 1;
        const downloadCount = { download };

        fetch(`https://madrumi.thakurgaonexpress.com/getanswer/${answer?._id}`, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(downloadCount)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
            });
    };

    // Handle pagination page click
    const handlePageClick = (data) => {
        setCurrentPage(data.selected + 1); // Update the current page
        window.scrollTo(0, 0);
    };

    return (
        <div className='w-10/12 lg:w-11/12 mx-auto mt-16 relative'>
            <ToastContainer />
            <h1 className='text-xl border-b-4 border-accent font-bold mt-8 inline-block'>
                মুফতি শফি সাহেব (দাঃ বাঃ) এর {category === "all" ? "সকল প্রশ্ন-উত্তর" : category + " বিষয়ে প্রশ্ন-উত্তর"}
            </h1><br />

            {/* Search Input */}
            <div className='flex justify-center items-center my-4'>
                <div className="form-control w-80">
                    <label className="label">
                        <span className="label-text font-bold">প্রশ্নের বিষয় লিখে অনুসন্ধান করুন</span>
                    </label>
                    <input
                        onChange={handleSearchResult}
                        type="text"
                        placeholder="প্রশ্নের বিষয় লিখুন"
                        className="input input-bordered input-accent w-full max-w-xs"
                    />
                </div>
            </div>

            <hr />

            {/* Show Loader */}
            {isLoading ? (
                <Loader />
            ) : (
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5'>
                    {answers.length > 0 ? answers.map(answer => (
                        <div key={answer._id} style={{ height: '250px' }} className='shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative'>
                            <h3 className='text-lg font-bold min-h-8'>প্রশ্নঃ {answer.question}</h3>
                            <h3 className='text-base'><span className='font-bold'>উত্তর নংঃ</span> {answer.answer_no}  <span className='font-bold'>  বিভাগঃ</span> {answer.category}</h3>
                            <div className='flex flex-row'>
                                <FaAssistiveListeningSystems className='text-xs' />
                                <p className='ml-px text-xs'>{answer?.view}</p>
                                <AiOutlineDownload className='text-xs ml-2' />
                                <p className='ml-px text-xs'>{answer?.download}</p>
                            </div>
                            <div className='mt-4 text-center absolute bottom-6 rounded-2xl left-12 shadow-2xl p-2'>
                                <label onClick={() => handlePlayAudio(answer)} htmlFor="my-modal-6" className="btn btn-accent btn-circle text-white font-bold mr-12">শুনুন</label>
                                <label
                                    onClick={() => handleDownloadAndSave(answer)}
                                    className={`btn ${downloadComplete[answer._id] ? 'btn-gray text-gray-500 cursor-not-allowed' : 'btn-accent text-white font-bold'}`}
                                    disabled={downloadComplete[answer._id]}
                                >
                                    {downloadComplete[answer._id] ? 'ডাউনলোড হয়েছে' : 'ডাউনলোড'}
                                </label>
                            </div>
                            {downloadProgress[answer._id] && downloadProgress[answer._id] < 100 && (
                                <div className='progress' style={{ backgroundColor: '#f0f0f0', borderRadius: '8px', height: '10px', marginTop: '2px' }}>
                                    <div
                                        className='progress-bar'
                                        role='progressbar'
                                        style={{
                                            width: `${Math.max(downloadProgress[answer._id], 1)}%`,
                                            backgroundColor: '#4caf50', // Set your preferred color here
                                            height: '100%',
                                            borderRadius: '8px',
                                            transition: 'width 0.5s ease' // Smooth transition
                                        }}
                                    >
                                        {Math.round(downloadProgress[answer._id])}%
                                    </div>
                                </div>
                            )}
                        </div>
                    )) : <p>No answers found</p>}
                </div>
            )}

            {/* Pagination */}
            <div className="flex justify-center mt-5 mb-20 flex-wrap">
                {pageCount > 0 && (
                    <ReactPaginate
                        previousLabel={<span className="text-gray-700">Previous</span>}
                        nextLabel={<span className="text-gray-700">Next</span>}
                        breakLabel={<span className="text-gray-700">...</span>}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"flex space-x-2 flex-wrap"}
                        pageClassName={"flex items-center justify-center bg-white border border-gray-300 hover:bg-gray-200 text-gray-700 font-medium py-1 px-2 rounded-md cursor-pointer"}
                        previousClassName={"flex items-center justify-center bg-gray-200 border border-gray-300 text-gray-700 font-medium py-1 px-2 rounded-md cursor-pointer"}
                        nextClassName={"flex items-center justify-center bg-gray-200 border border-gray-300 text-gray-700 font-medium py-1 px-2 rounded-md cursor-pointer"}
                        breakClassName={"flex items-center justify-center text-gray-700 font-medium py-1 px-2"}
                        activeClassName={"bg-accent text-white font-bold"}
                        disabledClassName={"bg-gray-300 text-gray-500 cursor-not-allowed"}
                    />
                )}
            </div>


        </div>
    );
};

export default MobileAnswers;

